import { Image, Box, Heading, Text, Button, Center, Link } from '@chakra-ui/react';
import { useRouteError } from 'react-router-dom';
import Logo from '../../assets/img/revolupay-logo.png'
import { useTranslation } from 'react-i18next';

export const Error = () => {
    const error = useRouteError();
    const { t } = useTranslation('layout');
    console.error(error);
    return (
        <Box textAlign='center' py={{ base: 10, md: 24 }} px={6}>
            <Center mb={12}>
                <Image sx={{ width: 500 }} src={Logo} />
            </Center>
            <Heading
                display='inline-block'
                color={'violet.900'}
                size='2xl'
            >
                💣
            </Heading>
            <Text fontSize='xl' mt={3} mb={2}>
                {t('ERROR_TITLE')}
            </Text>
            <Text color={'gray.500'} mb={6}>
                {t('ERROR_DESCRIPTION')}
            </Text>
            <Button
                as={Link}
                href='https://www.revolupay.es'
                size='lg'
                colorScheme='brand'
                variant='outline'>
                {t('RETURN_HOME')}
            </Button>
        </Box>
    );
}